export enum LayoutMethod {
  LAYERED = 'layered',
  FORCE = 'force',
}

export enum DiagnosticType {
  None = 'none',
  Fault = 'fault',
  Observable = 'observable',
}

export enum Monotonicity {
  ascending = 'ascending',
  descending = 'descending',
  nonMonotonic = 'nonMonotonic',
}

export enum IntervalEndingEnum {
  Open = 'open',
  Closed = 'closed',
}
export enum NetworkStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  RELEASED = 'RELEASED',
  SNAPSHOT = 'SNAPSHOT',
}

export const VariableType = {
  Disease: 'Disease',
  Symptom: 'Symptom',
  Test: 'Test',
  Diagnosis: 'Diagnosis',
  Etiology: 'Etiology',
  Intervention: 'Intervention',
  MedicalProcedure: 'Medical procedure',
  MedicationOrSupplement: 'Medication/Supplement',
} as const
